export const normalizeHashRedirect = (hashPath: string): void => {
	if (typeof window === 'undefined') return;

	const { hash } = window.location;
	if (!hash.startsWith(`#${hashPath}`)) return;

	const [, query = ''] = hash.split('?');
	const search = query ? `?${query}` : '';
	window.history.replaceState(null, '', `${hashPath}${search}`);
};
